module.exports = __webpack_public_path__ + "static/media/cart.0f488bb4.png";